import { useBlockLayout, useExpanded, useFilters, useGlobalFilter, useGroupBy, useRowSelect, useSortBy, useTable } from "react-table";
import {
  cardInfo,
  column_edit_view,
  column_editable,
  column_Last,
  columns_first,
  creditCardPaymentColumns,
  ctid,
  virtualAccountInfo,
} from "./PaymentListColumns";

import { useMemo, useRef } from "react";
import { useSticky } from "react-table-sticky";
import { paymentCancelRequest } from "src/api/billingSchedule/billingSchedule-api";
import { CtPayment } from "src/api/contract/contract-types";
import { useApiOperation } from "src/api/hooks";
import ScrollShadowProvider from "src/components/ScrollShadowProvider";
import { useModal } from "src/recoil/modalState/hook";
import CreditCardPaymentCancelModal from "../creditCardPayment/CreditCardPaymentCancelModal";

interface DataBundle {
  paymentData: CtPayment[];
  pgcode: string;
  editable?: boolean | false;
  callList: any;
  callPaymentList: any;
  // getAccountAndPaymentInfo: () => Promise<void>;
  scheduleId: string;
}
interface Props {
  dataBundle: DataBundle;
}

const PaymentTable = ({ dataBundle }: Props) => {
  const tableRef = useRef<HTMLTableElement>(null);
  const { setAbstractModalZ1 } = useModal();
  const { executeAsync: paymentCancel } = useApiOperation(paymentCancelRequest);

  const {
    paymentData,
    pgcode,
    editable,
    callList, //
    // getAccountAndPaymentInfo,
    callPaymentList,
    scheduleId,
  } = dataBundle;

  const paymentColumns = useMemo(() => {
    let columns: any = [];

    if (pgcode === "creditcard") {
      if (editable) {
        cardInfo.forEach((col: any) => (col.width = 120));
        column_Last[0].width = 120;
        column_Last[1].width = 140;
        columns = columns_first.concat(ctid).concat(cardInfo).concat(column_Last);
        ctid.forEach((col: any) => (col.width = 120));
        column_editable[0].width = 320;
        // columns = columns.concat(ctid).concat(column_editable);
        columns = columns.concat(column_editable);
      } else {
        cardInfo.forEach((col: any) => (col.width = 160));
        column_Last[0].width = 160;
        column_Last[1].width = 160;
        columns = columns_first.concat(cardInfo).concat(column_Last);
        ctid.forEach((col: any) => (col.width = 120));
        column_edit_view[0].width = 220;
        columns = columns.concat(ctid).concat(column_edit_view);
      }
    }
    if (pgcode === "virtualaccount") {
      ctid.forEach((col: any) => (col.width = 200));
      column_Last[0].width = 180;
      column_Last[1].width = 200;
      columns = columns_first.concat(virtualAccountInfo).concat(column_Last).concat(ctid);
    }

    return pgcode === "creditcard" ? creditCardPaymentColumns : columns;
  }, [pgcode]);

  //
  // 결제 취소 요청
  const handlePaymentCancel = async ({ paymentId, cancelAmount }: { paymentId: string; cancelAmount: string }) => {
    await paymentCancel({ paymentId, cancelAmount });
    await callPaymentList();
    setAbstractModalZ1({ isOpen: false });
  };

  const openCreditCardPaymentCancelModal = (paymentInfo: CtPayment) => {
    setAbstractModalZ1({
      isOpen: true,
      size: "medium",
      children: (
        <CreditCardPaymentCancelModal //
          onClose={() => setAbstractModalZ1({ isOpen: false })}
          onPaymentCancel={handlePaymentCancel}
          paymentInfo={paymentInfo}
        />
      ),
    });
  };
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows, footerGroups } = useTable(
    {
      columns: paymentColumns,
      data: paymentData,
      editable,
      callList,
      callPaymentList,
      // getAccountAndPaymentInfo,
      scheduleId,
      openCreditCardPaymentCancelModal,
      initialState: {
        expanded: { 0: true }, // 첫 번째 행(index 0)을 펼침
      },
    },
    useSticky,
    useBlockLayout,
    useFilters,
    useGlobalFilter,
    useGroupBy,
    useSortBy,
    useExpanded,
    useRowSelect,
  );

  return (
    <div className="">
      <ScrollShadowProvider tableRef={tableRef}>
        <div {...getTableProps()} className="base-table sticky" ref={tableRef} style={{ maxHeight: "450px" }}>
          <div className="header">
            {headerGroups.map((headerGroup) => (
              <div {...headerGroup.getHeaderGroupProps()} className="base-table__tr">
                {headerGroup.headers.map((header) => {
                  return (
                    <div {...header.getHeaderProps()} className="base-table__th">
                      {header.render("Header")}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
          <div {...getTableBodyProps()} className="body ">
            {rows.map((row: any) => {
              prepareRow(row);
              return (
                <div {...row.getRowProps()} className={`base-table__tr ${row.values.floor ? "bg-gray100" : ""}`}>
                  {row.cells.map((cell: any) => {
                    return (
                      <div {...cell.getCellProps()} className="base-table__td">
                        {cell.render("Cell")}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </ScrollShadowProvider>
      <div className="overflow-x-hidden">
        {footerGroups.map((group) => {
          return (
            <div {...group.getFooterGroupProps()}>
              {group.headers.map((column) => (
                <div {...column.getFooterProps()} className="base-table__td base-table-footer">
                  {column.render("Footer")}
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PaymentTable;
